/**
 * Provider name constants for integrations
 * Centralized to prevent routing breakage when provider names change
 */

export const PROVIDER_NAMES = {
    JIRA_FOR_PENDO: 'Jira for Pendo',
    SLACK_FOR_AGENT_ANALYTICS: 'Slack for Agent Analytics',
    SLACK_FOR_PENDO_TRENDS: 'Slack for Pendo Trends',
    SALESFORCE_FOR_LISTEN: 'Salesforce for Listen',
    ZENDESK_FOR_LISTEN: 'Zendesk for Listen',
    GONG_FOR_LISTEN: 'Gong for Listen',
    ZOOM_FOR_LISTEN: 'Zoom for Listen',
    TEAMS_FOR_LISTEN: 'Teams for Listen',
};
